import { SIGN_IN_URI, DASHBOARD_API_ENDPOINT, FILE_UPLOAD_API_ENDPOINT, BUCKET } from "./oidc_constants";
import {WebStorageStateStore} from "oidc-client";

export const ApiConfig = {
  endpoint: process.env.REACT_APP_FILE_UPLOAD_API_GATEWAY_ENDPOINT,
  file_endpoint: FILE_UPLOAD_API_ENDPOINT,
  dashboard_endpoint:  DASHBOARD_API_ENDPOINT,
  bucket:  BUCKET
}

export const OidcConfig = {
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  authority: "https://cognito-idp.us-east-1.amazonaws.com/" + process.env.REACT_APP_USER_POOL_ID,
  client_id: process.env.REACT_APP_CLIENT_ID,
  redirect_uri: SIGN_IN_URI,
  response_type: 'code',
  scope: 'openid profile email'
};
